Vue.component('category-filter', {
    props: {
        categories: {
            required: true,
        },
        subMenu: {
            default: false,
        },
    },
    data() {
        return {
            cats: {},
        };
    },
    created() {
        this.cats = this.categories;
    },
    //language=HTML
    template: `
      <ul class="nav flex-column checkbox-menu" :class="{'sub-nav': subMenu}">
          <slot name="inUl"></slot>
          <category-filter-checkbox v-for="cat, key in cats" :key="key" :category="cat"></category-filter-checkbox>
      </ul>
  `,
});
